import state from './state.js'
import { validateEmail } from '../../lib/utils'
import { v4 as uuidv4 } from 'uuid';

export const serializeState = (flag = null) => {
  const resultsHandle = state.resultsHandle ?? `${Date.now()}-${uuidv4()}`
  if (!state.resultsHandle) {
    state.set({ resultsHandle })
  }
  const json = {
    updatedAt: new Date().toISOString(),
    quizHandle: state.quizHandle,
    resultsId: state.resultsId,
    resultsHandle,
    responses: state.responses,
    orderLines: state.orderLines,
    testIsCompleted: state.testIsCompleted,
    quizUrl: state.quiz.url,
    customer: {
      ...{},
      ...state.customer,
      email: validateEmail(state.customer.email) ? state.customer.email : (state.localStorage?.customer?.email ?? '')
    }
  }

  const serialized = JSON.stringify(json);

  const serializedWithFlag = flag ? JSON.stringify({
    ...{},
    ...json,
    ...flag,
  }) : serialized

  return {
    serialized,
    serializedWithFlag
  }
}